import EditUserInformationModal from 'components/modals/EditUserInformation'
import { RoleConvertor } from '../utils'
import EditIcon from 'assets/images/loans/edit.svg'
interface IItemProps {
    item: IMoneyPoolResults
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedUser: React.Dispatch<
        React.SetStateAction<IMoneyPoolResults | undefined>
    >
}
export default function Item({ item, setIsOpen, setSelectedUser }: IItemProps) {
    return (
        <>
            <div className=" my-3 text-sm w-full flex justify-between items-center">
                <div>
                    <div className=" flex items-center">
                        <p>
                            {item.member.first_name} {item.member.last_name}
                        </p>
                        <div className=" rounded-full bg-gray-5 py-1 px-2 mx-2 text-xs">
                            {item.number_of_shares} سهم
                        </div>
                    </div>
                    <p className=" mt-2 text-xs">
                        0{item.member.phone_number.slice(3)}{' '}
                        {item.is_active
                            ? item.role === 'nrm'
                                ? RoleConvertor[item.role]
                                : `- ${RoleConvertor[item.role]}`
                            : '- غیر فعال'}
                    </p>
                </div>
                <img
                    src={EditIcon}
                    alt="edit"
                    className=" w-5 h-5"
                    onClick={() => {
                        setIsOpen(true)
                        setSelectedUser(item)
                    }}
                />
            </div>
            <hr className="" />
        </>
    )
}
